import { useMemo } from 'react'
import { Card, Skeleton } from '@/ds'
import { useLoadedStay } from '@/app/stay/StayProvider'
import { partnerWidget } from '@/lib/partnerWidget'
import { useAsync } from '@/lib/useAsync'
import { extrasService } from '@/services/extras'
import { useLang } from '../Reserva/shared'

const PROVIDER_NAME = { civitatis: 'Civitatis' } as const

/**
 * "Experiencias de partner" (D14, actualizada por D55): el widget de Civitatis dentro de una tarjeta del sistema con
 * "Ofrecido por Civitatis". Solo para las reservas que hoy lo ven (Renthas). Cargando: esqueleto. Si el widget falla o no
 * trae actividades, el bloque no aparece y no se avisa de error: no es algo que el huésped haya pedido. El interior del
 * widget no sigue los tokens del sistema; solo se limita a 390 px sin romper el layout.
 */
export function PartnerExperiences() {
  const { t, lang } = useLang()
  const stay = useLoadedStay()
  const provider = extrasService.partnerProvider(stay)
  const [widget] = useAsync(`partner:${stay.guestCode}:${lang}:${provider ?? 'none'}`, (signal) => (provider ? extrasService.getPartnerWidget(stay, lang, signal) : Promise.resolve('')))
  const content = useMemo(() => (widget.kind === 'ready' ? partnerWidget(widget.value) : null), [widget])
  if (!provider) return null
  if (widget.kind === 'loading') {
    return (
      <div aria-busy="true">
        <Skeleton height={240} radius={16} />
      </div>
    )
  }
  if (!content || content.count === 0) return null
  return (
    <section className="pagos__group" aria-labelledby="extras-partner">
      <h2 id="extras-partner" className="pagos__h2">
        {t('v2.extras.partner.titulo')}
      </h2>
      <Card>
        <p className="extras__partner-by">{t('v2.extras.partner.ofrecido', { provider: PROVIDER_NAME[provider] })}</p>
        <div className="extras__partner">{content.nodes}</div>
      </Card>
    </section>
  )
}
